import React, { useContext, useMemo, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { isAdminUser } from "../utils/roleUtils";
import { decorateUiItems } from "../utils/uiConfig";
import { getUiIcon } from "../utils/uiIcons";
import Header from "./Header";
import Sidebar from "./Sidebar";
import "../pages/AdminHome.css";

function AppLayout() {
  const { user, uiConfig } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  const isAdmin = isAdminUser(user);

  const items = useMemo(() => {
    const withIcons = (list) =>
      list.map((item) => ({
        ...item,
        icon: getUiIcon(item.icon),
        children: Array.isArray(item.children) ? withIcons(item.children) : [],
      }));
    return withIcons(decorateUiItems(uiConfig?.sidebarItems || [], { isAdmin }));
  }, [isAdmin, uiConfig]);

  const currentPath = location.pathname + location.search;

  const handleNavigate = (itemId) => {
    if (itemId.startsWith("/")) {
      navigate(itemId);
    }
  };

  return (
    <>
      <Header
        onMenuToggle={() => setMobileSidebarOpen((previous) => !previous)}
        collapsed={sidebarCollapsed}
      />
      <div className="admin-layout">
        <Sidebar
          activeTab={currentPath}
          onNavigate={handleNavigate}
          collapsed={sidebarCollapsed}
          onToggle={() => setSidebarCollapsed((previous) => !previous)}
          mobileOpen={mobileSidebarOpen}
          onMobileClose={() => setMobileSidebarOpen(false)}
          items={items}
        />
        <main className={`admin-main ${sidebarCollapsed ? "sidebar-collapsed" : ""}`}>
          <Outlet />
        </main>
      </div>
    </>
  );
}

export default AppLayout;
